import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios, parseFilters } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
import { getUserFilters } from '@/helpers/permissions'
import i18n from '@/i18n/i18n'
const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
}
const initialState = () => {
  return {
    module: 'users',
    model: 'user',
    loading: false,
    list: [],
    selectList: [],
    userRoles: [],
    userSubscriptions: [],
    userFollowings: [],
    selected: {
      active: true,
      deleted: false,
      validated: false,
      register: 'backoffice',
      email: '',
      name: '',
      lastname1: '',
      lastname2: '',
      gender: '',
      birthdayDate: null,
      telf: '',
      password: '',
      countryId: '',
      provinceId: '',
      townId: '',
      address: '',
      cp: '',
      roles: [],
      // photo: 'default-user.png',
      defaultLanguages: 'es-ES',
    },
    idSelected: '',
    genders: ['male', 'female'],
    foot: ['right', 'left', 'ambidextrous'],
    filters: {},
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  genders(state) {
    return state.genders.map((item) => ({
      value: item,
      text: i18n.t(`fields.users.${item}`),
    }))
  },
  playerFoot(state) {
    return state.foot.map((item) => ({
      value: item,
      text: i18n.t(`fields.users.${item}`),
    }))
  },
  userFollowings(state) {
    return state.userFollowings.map((item) => {
      let type = ''
      if (item.type === 'club') {
        type = i18n.tc('models.entity')
      } else if (item.type === 'player') {
        type = i18n.tc('titles.global.player')
      } else {
        type = i18n.tc(`models.${item.type}`)
      }

      return { ...item, type }
    })
  },
  userSubscriptions(state) {
    return state.userSubscriptions.map((item) => ({
      ...item,
      typePayment: i18n.t(
        `fields.typeSubscriptions.typesPayment.${
          item.typePayment.split('-')[0]
        }`
      ),
      startAt: formatDate(item.startAt),
      expireAt: formatDate(item.expireAt),
    }))
  },
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => ({
      ...item,
      createdAt: formatDate(item.createdAt, true),
    }))
  },
}

const actions = {
  ...baseActions,
  async fetchList({ commit, state }, params = {}) {
    let { body, query } = parseFilters(state, params, getUserFilters(params))
    body.noValidate = true
    if (body.deleted) body.deleted = 'all'
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/format', body, { params: { ...query } })
      .finally(() => commit('setLoading', false))

    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async fetchSelectList({ commit, state }, params = {}) {
    let set = true
    let query = {}
    if (params.set === false) {
      set = false
      delete params.set
    }
    let body = Object.assign({}, params, getUserFilters(params))
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/select', body, { params: query })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    if (set) commit('setSelectList', list)
    return list
  },
  async updateProfile({ commit, state, dispatch }, payload) {
    commit('setLoading', true)
    const userId = payload.userId
    delete payload.userId
    const { data } = await apiAxios
      .post(`${state.module}/profile/add/${userId}`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    const item = data.data ? data.data[state.model] : {}
    dispatch('fetchOne', userId)
    return item
  },
  async enrole({ commit, dispatch }, payload = {}) {
    let { view, userId, userRoleId, unrole, force } = payload
    try {
      let path = unrole ? 'reject_role' : 'confirm_role'
      commit('setLoading', true)
      let { data } = await apiAxios.post(
        `${state.module}/${path}/${userId}/${userRoleId}`,
        {
          force,
        }
      )

      notify(data.message)
    } finally {
      if (view === 'home') {
        dispatch('stats/fetchPendingUsers', {}, { root: true })
      } else if (view === 'user') {
        dispatch('fetchUserRoles', userId)
      }
      if (view !== 'player-familiars') {
        dispatch('notifications/fetchConfirmRoleList', {}, { root: true })
      }
      commit('setLoading', false)
    }
  },
  async assignRole({ commit, dispatch }, payload = {}) {
    try {
      commit('setLoading', true)
      let { data } = await apiAxios.post(`roles/enrole`, payload)
      dispatch('fetchUserRoles', payload.userId)
      notify(data.message)
    } finally {
      commit('setLoading', false)
    }
  },
  async fetchUserRoles({ commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${id}/roles`)
      .finally(() => commit('setLoading', false))
    const roles = data.data ? data.data.roles : []
    commit('setUserRoles', roles)
    return roles
  },
  async fetchUserSubscriptions({ commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${id}/subscriptions`)
      .finally(() => commit('setLoading', false))
    const subscriptions = data.data ? data.data.subscriptions : []
    commit('setUserSubscriptions', subscriptions)
    return subscriptions
  },
  async fetchUserFollowings({ commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/followings/${id}`)
      .finally(() => commit('setLoading', false))
    const followings = data.data ? data.data.followings : []
    commit('setUserFollowings', followings)
    return followings
  },
  async deleteUserSession({ commit, state }, email) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`${state.module}/logout/`, { email, access: 'all' })
      .finally(() => commit('setLoading', false))
    notify(data.message)
  },
  async sendRegisterInvitation({ commit, state }, payload) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`${state.module}/send-register-invitation/`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
  },
  async bulkCreate({ commit }, payload) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`users/bulk-create/`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
  },
}

const mutations = {
  ...baseMutations,
  setUserRoles(state, payload) {
    state.userRoles = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.userRoles.push(item))
    }
  },
  setUserSubscriptions(state, payload) {
    state.userSubscriptions = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.userSubscriptions.push(item))
    }
  },
  setUserFollowings(state, payload) {
    state.userFollowings = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.userFollowings.push(item))
    }
  },
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
    state.userRoles = []
    state.userFollowings = []
    state.userSubscriptions = []
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
